import {
  all, put, takeEvery, select, takeLatest, fork, join, call,
} from 'redux-saga/effects';
import { getCurrentAuthHeader } from 'domain/fuse/auth/utils';
import { getResults } from 'circe/queryListing/selectors';
import { changeData } from 'circe/queryListing/actions';
import * as I18n from 'circe/I18n';
import { show as showNotification } from 'circe/notifications/actions';
import { exception } from 'circe/logger';
import moment from 'moment';
import * as api from './api';
import { REDUCER_NAME, STATUS_MAP } from './constants';
import { approve, reject } from './actions';

function* doApprove(action) {
  const { payload } = action;

  const { profileId, doc, values } = payload;

  const state = yield select();

  const docs = yield call(getResults, state, REDUCER_NAME);

  const { fileId } = doc;

  try {
    yield put(
      changeData(
        REDUCER_NAME,
        docs.map((doc) => {
          if (doc.fileId === fileId) {
            return {
              ...doc,
              isApproving: true,
            };
          }
          return doc;
        }),
      ),
    );

    const toUpdate = {
      ...doc,
      ...values,
      expiryDate: moment(values.expiryDate)
        .endOf('day')
        .toISOString(),
      reason: 'APPROVED',
      approvalStatus: STATUS_MAP.APPROVED,
    };

    yield call(api.approve, profileId, toUpdate);

    const allDocs = docs.map((doc) => {
      if (doc.fileId === fileId) {
        return {
          ...doc,
          ...toUpdate,
          isApproving: false,
        };
      }
      return doc;
    });

    yield put(changeData(REDUCER_NAME, allDocs));

    yield put(
      showNotification(
        I18n.str('driverDocApproved', 'Driver document has been approved successfully.'),
      ),
    );
  } catch (error) {
    yield put(
      changeData(
        REDUCER_NAME,
        docs.map((doc) => {
          if (doc.fileId === fileId) {
            return {
              ...doc,
              isApproving: false,
            };
          }
          return doc;
        }),
      ),
    );

    yield put(
      showNotification(
        I18n.str('driverDocApprovalFailed', 'an error occurred during driver document approval.'),
        'error',
      ),
    );
    exception(error);
  }
}

function* doReject(action) {
  const { payload } = action;

  const { profileId, doc, values } = payload;

  const state = yield select();

  const docs = yield call(getResults, state, REDUCER_NAME);

  const { fileId } = doc;

  try {
    yield put(
      changeData(
        REDUCER_NAME,
        docs.map((doc) => {
          if (doc.fileId === fileId) {
            return {
              ...doc,
              isRejecting: true,
            };
          }
          return doc;
        }),
      ),
    );

    let expiryDate;

    try {
      expiryDate = moment(values.expiryDate);
    } catch (error) {
      expiryDate = moment();
    }

    const toUpdate = {
      ...doc,
      ...values,
      expiryDate: doc.expiryDate || expiryDate.endOf('day').toISOString(),
      approvalStatus: STATUS_MAP.REJECTED,
    };

    yield call(api.reject, profileId, toUpdate);

    const allDocs = docs.map((doc) => {
      if (doc.fileId === fileId) {
        return {
          ...doc,
          ...toUpdate,
          isRejecting: false,
        };
      }
      return doc;
    });

    yield put(changeData(REDUCER_NAME, allDocs));

    yield put(
      showNotification(I18n.str('driverDocRejected', 'Driver document has been rejected.')),
    );
  } catch (error) {
    yield put(
      changeData(
        REDUCER_NAME,
        docs.map((doc) => {
          if (doc.fileId === fileId) {
            return {
              ...doc,
              isRejecting: false,
            };
          }
          return doc;
        }),
      ),
    );

    yield put(
      showNotification(
        I18n.str('driverDocRejectionFailed', 'an error occurred during driver document rejection.'),
        'error',
      ),
    );
    exception(error);
  }
}

function* watcher(context) {
  yield all([takeEvery(approve().type, doApprove), takeEvery(reject().type, doReject)]);
}

export default watcher;
